import { render, staticRenderFns } from "./Plantas.vue?vue&type=template&id=47e51f8a&lang=pug&"
import script from "./Plantas.vue?vue&type=script&lang=js&"
export * from "./Plantas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports